import React, { Component } from 'react';
import GetContenedorFacturacion from './getContenedorFacturacion';
class getNewPedido extends Component {
  constructor(props){
    super(props)
  }
  regresar =()=>{
    this.props.get_salir_vista_pedido()
  }
  render() {

    return(
      <React.Fragment>
        <GetContenedorFacturacion database={this.props.database} uuid_agente={this.props.uuid_agente} usuario={this.props.usuario}  regresar={this.regresar} separator={this.props.separator} url_image={this.props.url_image}  firebase={this.props.firebase} file_500x200={this.props.file_500x200} file_250x200={this.props.file_250x200} file_60x60={this.props.file_60x60} token={this.props.token} dir_url={this.props.dir_url}/>
      </React.Fragment>
    )
  }

  componentDidMount (){

  }

}
export default getNewPedido;
